import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {PageTitle} from '../../_metronic/layout/core'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../setup'
// import CreditsPage from '../modules/credits/CreditsPage'
import ExtrernalUrls from '../modules/external/ExtrernalUrls'
import FirmwareAccessGuard from '../modules/firmware/components/FirmwareAccessGuard'
// import PlaylistView from '../components/playlist/PlaylistView'
// import ConfigurationView from '../components/configuration/ConfigurationView'

const PrivateRoutes = () => {
  const role = useSelector<RootState>(({auth}) => auth.role, shallowEqual)

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const DevicesPage = lazy(() => import('../modules/device/DevicesPage'))
  const StatisticsPage = lazy(() => import('../modules/statistics/StatisticsPage'))
  const MessagePage = lazy(() => import('../modules/message/MessagePage'))
  const UserPage = lazy(() => import('../modules/user/UserPage'))
  const ConfigurationPage = lazy(() => import('../modules/configuration/ConfigurationPage'))
  const PlaylistPage = lazy(() => import('../modules/playlist/PlaylistPage'))
  const GeozonePage = lazy(() => import('../modules/geozone/GeozonePage'))
  const StorePage = lazy(() => import('../modules/store/StorePage'))
  const CustomerPage = lazy(() => import('../modules/customer/CustomerPage'))
  const AppButtonPage = lazy(() => import('../modules/appButtons/AppButtonPage'))
  const SchedulePage = lazy(() => import('../modules/schedule/SchedulePage'))
  const CommandsPage = lazy(() => import('../modules/commands/CommandsPage'))
  const MultiListPage = lazy(() => import('../modules/multilist/MultiListPage'))
  const CampaignPage = lazy(() => import('../modules/campaign/CampaignPage'))
  const CreditsPage = lazy(() => import('../modules/credits/CreditsPage'))
  const SubscriptionsPage = lazy(() => import('../modules/subscriptions/SubscriptionsPage'))
  const FirmwareBuildsPage = lazy(() => import('../modules/firmware/FirmwareBuildsPage'))
  const FirmwareRolloutsPage = lazy(() => import('../modules/firmware/FirmwareRolloutsPage'))
  const FirmwareRolloutProgressPage = lazy(
    () => import('../modules/firmware/FirmwareRolloutProgressPage')
  )

  const maintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {maintenanceMode != 'true' ||
        (maintenanceMode == 'true' && localStorage.getItem('maintenanceMode') == 'true') ? (
          <>
            <Route
              path='/'
              element={
                <Navigate to={role === 'Factory' ? '/devices/list' : '/dashboard'} replace />
              }
            />
            {/* <Route path="auth/*" element={<Navigate to={role === 'Factory' ? '/devices/list' : '/dashboard'} />} /> */}

            {
              role == 'Factory' ? (
                <Route path='auth/*' element={<Navigate to='/devices/list' />} />
              ) : (
                // <Route index element={<Navigate to='/devices/list' />} />
                <Route path='auth/*' element={<Navigate to='/dashboard' />} />
              )
              // <Route index element={<Navigate to='/dashboard' />} />
            }

            <Route path='/dashboard' element={<DashboardWrapper />} />

            {/* <Route path='auth/*' element={<Navigate to='/devices/list' />} /> */}
            {/* <Redirect from='/auth' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' /> */}
            <Route
              path='/devices/*'
              element={
                <SuspensedView>
                  <DevicesPage />
                </SuspensedView>
              }
            />

            <Route
              path='/configuration/*'
              element={
                <SuspensedView>
                  <ConfigurationPage />
                </SuspensedView>
              }
            />

            {/*
            ITOP-928 / ITOP-925. The firmware routes are registered for EVERY role; what a role
            may do is decided by FirmwareAccessGuard, which tells a refused role it is not
            authorised. They used to exist only for Admin, so a Company login that was shown the
            menu entry landed on "Page Not Found" (ITOP-925).

            Rollouts: Admin and Company (Kalle's 1b/2c). Builds: Admin only (7a). The gates are
            cosmetic; the backend enforces both (ITOP-927).
          */}
            {/* FE-009. The firmware registry — see, register, withdraw. Admin only. */}
            <Route
              path='/firmware-builds'
              element={
                <FirmwareAccessGuard permission='builds'>
                  <SuspensedView>
                    <FirmwareBuildsPage />
                  </SuspensedView>
                </FirmwareAccessGuard>
              }
            />

            {/* FE-016 — the way back to a rollout. A distinct path rather than an index
              under '/firmware-rollout', so a pasted uid still resolves to the progress
              page and neither route shadows the other.

              Starting a rollout and listing them are now two tabs of this one page.
              They were two sidebar entries a single letter apart — "Firmware Rollout"
              and "Firmware Rollouts" — where picking wrong put an operator on a form
              that dispatches firmware. */}
            <Route
              path='/firmware-rollouts'
              element={
                <FirmwareAccessGuard permission='rollout'>
                  <SuspensedView>
                    <FirmwareRolloutsPage />
                  </SuspensedView>
                </FirmwareAccessGuard>
              }
            />
            {/* The old start-a-rollout path. Kept as a redirect rather than deleted:
              it is in browser histories and bookmarks, and 404-ing someone who used
              the feature yesterday is a worse answer than sending them to the tab that
              replaced it. The target is guarded, so a refused role is refused there. */}
            <Route
              path='/firmware-rollout'
              element={<Navigate to='/firmware-rollouts?tab=start' replace />}
            />

            {/* Progress for one rollout. A separate route rather than state on the
              selection page, because this must be linkable: an operator bookmarks a
              running rollout, reloads it, or opens it the next morning. */}
            <Route
              path='/firmware-rollout/:rolloutId'
              element={
                <FirmwareAccessGuard permission='rollout'>
                  <SuspensedView>
                    <FirmwareRolloutProgressPage />
                  </SuspensedView>
                </FirmwareAccessGuard>
              }
            />

            <Route
              path='/learn'
              element={
                <SuspensedView>
                  <ExtrernalUrls url={'https://emely6538.softr.app'} />
                </SuspensedView>
              }
            />

            <Route
              path='/faq'
              element={
                <SuspensedView>
                  <ExtrernalUrls url={'https://emely6538.softr.app/faq'} />
                </SuspensedView>
              }
            />

            <Route
              path='/glossary'
              element={
                <SuspensedView>
                  <ExtrernalUrls url={'https://emely6538.softr.app/glossary'} />
                </SuspensedView>
              }
            />

            <Route
              path='/playlists/*'
              element={
                <SuspensedView>
                  <PlaylistPage />
                </SuspensedView>
              }
            />

            <Route
              path='/campaigns/*'
              element={
                <SuspensedView>
                  <CampaignPage />
                </SuspensedView>
              }
            />

            <Route
              path='/geo-zone/*'
              element={
                <SuspensedView>
                  <GeozonePage />
                </SuspensedView>
              }
            />

            <Route
              path='/statistics/*'
              element={
                <SuspensedView>
                  <StatisticsPage />
                </SuspensedView>
              }
            />

            <Route
              path='/messages/*'
              element={
                <SuspensedView>
                  <MessagePage />
                </SuspensedView>
              }
            />

            <Route
              path='/user/*'
              element={
                <SuspensedView>
                  <UserPage />
                </SuspensedView>
              }
            />

            <Route
              path='/store/*'
              element={
                <SuspensedView>
                  <StorePage />
                </SuspensedView>
              }
            />

            {role == 'PG' && (
              <Route
                path='/customers/*'
                element={
                  <SuspensedView>
                    <CustomerPage />
                  </SuspensedView>
                }
              />
            )}

            <Route
              path='/credits/*'
              element={
                <SuspensedView>
                  <CreditsPage />
                </SuspensedView>
              }
            />

            <Route
              path='/subscriptions/*'
              element={
                <SuspensedView>
                  <SubscriptionsPage />
                </SuspensedView>
              }
            />

            <Route
              path='/schedules/*'
              element={
                <SuspensedView>
                  <SchedulePage />
                </SuspensedView>
              }
            />

            <Route
              path='/multilist/*'
              element={
                <SuspensedView>
                  <MultiListPage />
                </SuspensedView>
              }
            />

            <Route
              path='/app/*'
              element={
                <SuspensedView>
                  <AppButtonPage />
                </SuspensedView>
              }
            />

            <Route
              path='/admin/*'
              element={
                <SuspensedView>
                  <CommandsPage />
                </SuspensedView>
              }
            />

            <Route
              path='/scheduling'
              element={
                <SuspensedView>
                  <PageTitle
                    breadcrumbs={[
                      {
                        title: 'scheduling',
                        path: 'configuration',
                        isSeparator: false,
                        isActive: false,
                      },
                    ]}
                  >
                    Scheduling
                  </PageTitle>
                </SuspensedView>
              }
            />

            {/* <Redirect to='error/404' /> */}

            <Route
              path='crafted/pages/profile/*'
              element={
                <SuspensedView>
                  <ProfilePage />
                </SuspensedView>
              }
            />
            <Route path='*' element={<Navigate to='/error/404' />} />
          </>
        ) : (
          <>
            <Route path='*' element={<Navigate to='/maintenance' />} />
          </>
        )}
      </Route>

      {/* <Route path='/mobile/playlist' element={
        <PlaylistView />
      } />

      <Route path='/mobile/configuration' element={
        <ConfigurationView />
      } /> */}
    </Routes>
  )
}

const SuspensedView: FC = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
